import { myV1ActionEvent } from '../../../../v4/migration/actionAsEventMiddleware.connected';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myResourceApi } from 'v5/api/resource/resource.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createResourceService } from './ResourceService.impl';

export const myResourceService = createResourceService({
  api: myResourceApi,
  queryClient,
  v1Event: myV1ActionEvent,
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  }
});
